import { faRobot as IconeParticipacaoVirtual } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Component } from 'react';
import MuiUtil from '@/util/MuiUtil';

class IconeAdvogadoParticipacaoVirtual extends Component {
    static titlePadrao = (<Typography>Pedido de participação virtual</Typography>);
    static corPadrao = 'black';
    static opacidadePadrao = '1';
    static tamanhoPadrao = '24px';
    removerTooltip = false;
    removerEstiloPadrao = false;

    static get sxPadrao() {
        return {
            color: IconeAdvogadoParticipacaoVirtual.corPadrao,
            fill: IconeAdvogadoParticipacaoVirtual.corPadrao,
            fillOpacity: IconeAdvogadoParticipacaoVirtual.opacidadePadrao,
            width: IconeAdvogadoParticipacaoVirtual.tamanhoPadrao,
            height: IconeAdvogadoParticipacaoVirtual.tamanhoPadrao
        };
    }

    constructor(props) {
        super(props);

        let { removerEstiloPadrao, removerTooltip, title, ...propsIcone } = this.props;

        // Carrega as propriedades do tooltip
        this.removerTooltip = removerTooltip !== undefined ? removerTooltip : this.removerTooltip;
        this.title = title !== undefined ? title : IconeAdvogadoParticipacaoVirtual.titlePadrao;

        // Carrega as propriedades do ícone
        this.removerEstiloPadrao = removerEstiloPadrao !== undefined ? removerEstiloPadrao : this.removerEstiloPadrao;

        if (this.removerEstiloPadrao) {
            this.propsIcone = propsIcone;
        } else {
            this.propsIcone = MuiUtil.mesclarSxStyle(propsIcone);
            this.adicionarSxPadrao();
        }
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            this.propsIcone.sx = IconeAdvogadoParticipacaoVirtual.sxPadrao;
        } else {
            this.propsIcone.sx = { ...IconeAdvogadoParticipacaoVirtual.sxPadrao, ...this.propsIcone.sx };
        }
    }

    render() {
        if (this.removerTooltip) {
            return (
                <FontAwesomeIcon
                    icon={IconeParticipacaoVirtual}
                    {...this.propsIcone}
                />
            );
        } else {
            return (
                <Tooltip title={this.title}>
                    <FontAwesomeIcon
                        icon={IconeParticipacaoVirtual}
                        {...this.propsIcone}
                    />
                </Tooltip>
            );
        }
    }
}

IconeAdvogadoParticipacaoVirtual.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node
};

export default IconeAdvogadoParticipacaoVirtual;
